import { horaCorta } from '@/shared/utilidades/formato'

import { useMisRecogidas } from './useRecogidas'
import estilos from './MisHerramientas.module.css'

/**
 * LAS HERRAMIENTAS QUE ME TOCA IR A RECOGER (0239).
 *
 * El gerente asignó a este operario una recogida que pidió un técnico. Aquí
 * está qué, de quién, dónde y la nota que dejó; «Cómo llegar» abre el mapa.
 *
 * La recogida termina en la bodega, escaneando el QR de la herramienta —la
 * misma pantalla de devolver—. No hay botón de «ya la recogí» a propósito:
 * igual que con la devolución, la herramienta vuelve cuando alguien en bodega
 * la tiene en la mano, y hasta ese escaneo sigue a nombre del técnico.
 *
 * Usa el mismo lenguaje visual que «Herramienta a tu nombre»: es la misma
 * cosa vista desde el otro lado.
 */
export function MisRecogidas() {
  const { recogidas } = useMisRecogidas()

  if (recogidas.length === 0) return null

  return (
    <section className={estilos.zona}>
      <header className={estilos.cabecera}>
        <span className={estilos.insignia} aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z" />
            <circle cx="7" cy="17.5" r="1.8" />
            <circle cx="17" cy="17.5" r="1.8" />
          </svg>
        </span>
        <span className={estilos.titulo}>Recogidas a tu cargo</span>
        <span className={estilos.cuenta}>{recogidas.length}</span>
      </header>

      <ul className={estilos.lista}>
        {recogidas.map((r) => {
          const destino =
            r.latitud !== null && r.longitud !== null
              ? `${r.latitud},${r.longitud}`
              : encodeURIComponent(r.direccion)
          return (
            <li key={r.recogida_id} className={estilos.herramienta}>
              <div className={estilos.tope}>
                <span className={estilos.nombre}>{r.herramienta}</span>
                <span className={estilos.dias}>desde las {horaCorta(r.asignada_en)}</span>
              </div>
              <p className={estilos.meta}>
                <b>{r.etiqueta}</b> · la dejó {r.de_quien}
              </p>
              <p className={estilos.donde}>
                <b>Dónde:</b> {r.direccion}
                {r.nota && (
                  <>
                    <br />
                    <b>Nota:</b> {r.nota}
                  </>
                )}
              </p>
              <div className={estilos.comoDevolver}>
                <b>Llévala a la bodega y escanea su código QR</b> para entregarla. Hasta ese escaneo
                sigue a nombre de {r.de_quien.split(' ')[0]}.
              </div>
              <a
                className={`${estilos.accion} ${estilos.accionAncha}`}
                href={`https://www.google.com/maps/dir/?api=1&destination=${destino}`}
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  viewBox="0 0 24 24"
                  width="17"
                  height="17"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M12 21s-6-5.3-6-10.5a6 6 0 0 1 12 0C18 15.7 12 21 12 21Z" />
                  <circle cx="12" cy="10.5" r="2.2" />
                </svg>
                Cómo llegar
              </a>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
